export const getSupportedMimeType = () => {
  const types = [
    "audio/webm;codecs=opus",
    "audio/ogg;codecs=opus",
    "audio/mp4",
    "audio/wav",
  ];
  return types.find((type) => MediaRecorder.isTypeSupported(type)) || "";
};

// export const generateAudioBlobByChunks = (chunks: Blob[]) => {
//   const mimeType = getSupportedMimeType();
//   return new Blob(chunks, {
//     type: mimeType,
//   });
// };

export async function generateAudioBlobByChunks(chunks: Blob[]) {
  const mimeType = getSupportedMimeType();
  const audioContext = new AudioContext();

  const audioBuffers = await Promise.all(
    chunks.map((chunk) =>
      chunk.arrayBuffer().then((buffer) => audioContext.decodeAudioData(buffer))
    )
  );

  const totalLength = audioBuffers.reduce(
    (sum, buffer) => sum + buffer.length,
    0
  );
  const outputBuffer = audioContext.createBuffer(
    audioBuffers[0].numberOfChannels,
    totalLength,
    audioBuffers[0].sampleRate
  );

  let offset = 0;
  for (const buffer of audioBuffers) {
    for (let channel = 0; channel < buffer.numberOfChannels; channel++) {
      outputBuffer
        .getChannelData(channel)
        .set(buffer.getChannelData(channel), offset);
    }
    offset += buffer.length;
  }

  // exporta com base no mimeType com metadados corretos
  return audioBufferToBlob(outputBuffer, mimeType);
}

function audioBufferToBlob(buffer: AudioBuffer, mimeType: string): Blob {
  const numOfChan = buffer.numberOfChannels,
    length = buffer.length * numOfChan * 2 + 44,
    bufferArray = new ArrayBuffer(length),
    view = new DataView(bufferArray),
    channels = [],
    sampleRate = buffer.sampleRate;

  let offset = 0;

  function writeString(str: string) {
    for (let i = 0; i < str.length; i++) {
      view.setUint8(offset++, str.charCodeAt(i));
    }
  }

  // RIFF chunk descriptor
  writeString("RIFF");
  view.setUint32(offset, 36 + buffer.length * 2, true);
  offset += 4;
  writeString("WAVE");

  // FMT sub-chunk
  writeString("fmt ");
  view.setUint32(offset, 16, true);
  offset += 4;
  view.setUint16(offset, 1, true);
  offset += 2;
  view.setUint16(offset, numOfChan, true);
  offset += 2;
  view.setUint32(offset, sampleRate, true);
  offset += 4;
  view.setUint32(offset, sampleRate * 2 * numOfChan, true);
  offset += 4;
  view.setUint16(offset, numOfChan * 2, true);
  offset += 2;
  view.setUint16(offset, 16, true);
  offset += 2;

  // data sub-chunk
  writeString("data");
  view.setUint32(offset, buffer.length * 2, true);
  offset += 4;

  for (let i = 0; i < buffer.numberOfChannels; i++) {
    channels.push(buffer.getChannelData(i));
  }

  for (let i = 0; i < buffer.length; i++) {
    for (let c = 0; c < numOfChan; c++) {
      const sample = Math.max(-1, Math.min(1, channels[c][i]));
      view.setInt16(
        offset,
        sample < 0 ? sample * 0x8000 : sample * 0x7fff,
        true
      );
      offset += 2;
    }
  }

  return new Blob([bufferArray], { type: mimeType });
}
